// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminApprovals = (client) => ({
    /**
     * `GET /admin/approvals`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/approvals/route.ts
     */
    list: (query, headers) => client.fetch("/admin/approvals", { method: "GET", query, headers }),
    /**
     * `POST /admin/approvals/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-quote-management/src/api/admin/approvals/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/admin/approvals/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=approvals.js.map